<div class="offer">
    <div class="summary-container">
        <div class="summary-title">
            <ng-container *ngIf="!transportRequest?.id">
                {{ 'TRANSPORT|Zgłaszanie transportu' | translate }}
            </ng-container>
            <ng-container *ngIf="transportRequest?.id">
                {{ 'TRANSPORT|Obsługa zgłoszenia transportu' | translate }}
            </ng-container>
        </div>
        <div *ngIf="transportRequest?.id" class="document-title">
            <p>
                {{ 'TRANSPORT|Zgłoszenie {documentNumber} z dnia {requestDate}' | translate : {documentNumber: transportRequest.documentNumber?.join(''), requestDate: (transportRequest.created | date) } }}
            </p>
        </div>
        <div class="icc-card document-order-number" *ngIf="transportRequest?.complaintDocumentNumber">
            <span class="icc-card__label">
                {{ 'COMPLAINT|Numer reklamacji' | translate }}
            </span>
            <span class="icc-card__detail">
                {{ transportRequest?.complaintDocumentNumber?.join('') }}
            </span>
        </div>
        <div class="icc-card document-status-card" *ngIf="transportRequest?.id">
            <span class="icc-card__label">
                {{ 'TRANSPORT|Status:' | translate }}
            </span>
            <span class="icc-card__detail">
                <icc-transport-status *ngIf="!hasAccessTo.manage" [status]="transportRequest.status"></icc-transport-status>
                <icc-form-field
                    size="small"
                    *ngIf="hasAccessTo.manage"
                >
                    <icc-icon name="state"  [ngStyle]="{'color': '#'+statusColorHex}" ></icc-icon>
                    <icc-select
                        size="small"
                        [value]="transportRequest.status"
                        (valueChange)="changeStatus($event)"
                        name="document-status"
                        >
                        <option *ngFor="let el of transportStatuses" [value]="el.value" >
                            {{ el.label | translate}}
                        </option>
                    </icc-select>
                </icc-form-field>

            </span>
        </div>
        <div class="icc-card" *ngIf="transportRequest?.id && (transportRequest.pickupDate || hasAccessTo.manage)">
            <span class="icc-card__label">
                {{ 'TRANSPORT|Data odbioru' | translate }}
            </span>
            <span class="icc-card__content__header" *ngIf="!editPickupDate">
                <ng-container *ngIf="transportRequest.pickupDate">{{ transportRequest.pickupDate | date: 'shortDate' }}</ng-container>
                <ng-container *ngIf="!transportRequest.pickupDate && hasAccessTo.manage"><i class="errorMessage">{{ 'TRANSPORT|Wprowadź datę odbioru' | translate}}</i></ng-container>

                <button *ngIf="hasAccessTo.manage" iccIconButton appearance="flat" (click)="editPickupDate = true;focusInput('pickupDate')">
                    <icc-icon name="edit"></icc-icon>
                </button>
            </span>
            <div
                *ngIf="editPickupDate"
                class="icc-card__content__header"
            >
                <div class="width-90">
                    <icc-input
                        [value]="pickupDate"
                        (valueChange)="pickupDate = $event"
                        name="pickupDate"
                        type="date"
                        #pickupDateInput
                        [dateErrorMessage]="'TRANSPORT|Wprowadź datę w formacie: dd.mm.rrrr' | translate"
                    ></icc-input>
                </div>
                <div class="width-10">
                    <button
                        iccIconButton
                        appearance="flat"
                        (click)="changePickupDate()"
                    >
                        <icc-icon name="done"></icc-icon>
                    </button>
                    <button
                        iccIconButton
                        appearance="flat"
                        (click)="closeEditPickupDate()"
                    >
                        <icc-icon name="close"></icc-icon>
                    </button>
                </div>
            </div>
        </div>

        <div class="flex-horizontal wrap-conditional" *ngIf="transportRequest?.id || (hasAccessTo.manage && transportRequest?.contractorCompanyName)">
            <div class="document-card_data">
                <span class="document-card_data__label">
                    {{ 'TRANSPORT|Kontrahent:' | translate }}
                </span>
                <div class="document-card_data__content">
                    <div class="document-card_data__content-box">
                        <span class="document-card_data__content-box__wrapper">
                            <b class="document-card_data__content-box__company_name">{{ transportRequest?.contractorCompanyName }} <span *ngIf="transportRequest?.contractorExtId">({{ transportRequest?.contractorExtId }})</span><br></b>
                            <span>{{ transportRequest?.contractorName }}<br></span>
                        </span>
                    </div>
                </div>
            </div>
            <div class="document-card_data" *ngIf="transportRequest?.id">
                <span class="document-card_data__label">
                    {{ 'TRANSPORT|Adres odbioru:' | translate }}
                </span>
                <div class="document-card_data__content">
                    <div class="document-card_data__content-box">
                        <span class="document-card_data__content-box__wrapper">
                            <b class="document-card_data__content-box__company_name document-description">{{transportRequest.pickupAddress}}<br></b>
                            <span *ngIf="transportRequest.pickupPhoneNumber">{{ 'CONTACT|tel.' | translate }} {{transportRequest.pickupPhoneNumber}}</span>
                        </span>
                    </div>
                </div>
            </div>
            <div class="document-card_data" *ngIf="transportRequest && transportRequest?.id && (transportRequest.driverUserId || hasAccessTo.manage)">
                <span class="document-card_data__label">
                    {{ 'TRANSPORT|Kierowca:' | translate }}
                </span>
                <div class="document-card_data__content">
                    <div class="document-card_data__content-box">
                        <span class="document-card_data__content-box__wrapper">
                            <i class="errorMessage" *ngIf="!editDriver && !transportRequest.driverUserId" (click)="editDriver = true">{{ 'TRANSPORT|Zleć transport kierowcy' | translate}}</i>
                            <b class="document-card_data__content-box__company_name document-description" *ngIf="!editDriver">{{ drivers[transportRequest.driverUserId]?.name }}<br></b>
                            <span *ngIf="!editDriver && drivers[transportRequest.driverUserId]?.phoneNumber">{{ 'CONTACT|tel.' | translate }} {{ drivers[transportRequest.driverUserId]?.phoneNumber }}</span>
                            <div>
                                <icc-form-field
                                    size="small"
                                    *ngIf="editDriver"
                                >
                                    <icc-select
                                        size="small"
                                        [(ngModel)]="driverUserId"
                                        name="document-driver"
                                        >
                                        <option *ngFor="let el of drivers | keyvalue" [value]="el.key" >
                                            {{ el.value.name }} <ng-container *ngIf="el.value.phoneNumber">({{ el.value.phoneNumber }})</ng-container>
                                        </option>
                                    </icc-select>
                                </icc-form-field>
                                <div class="width-10" *ngIf="editDriver">
                                    <button
                                        iccIconButton
                                        appearance="flat"
                                        (click)="changeDriver()"
                                    >
                                        <icc-icon name="done"></icc-icon>
                                    </button>
                                    <button
                                        iccIconButton
                                        appearance="flat"
                                        (click)="closeEditDriver()"
                                    >
                                        <icc-icon name="close"></icc-icon>
                                    </button>
                                </div>
                            </div>

                            <div class="document-card_data__content-box__actions" *ngIf="hasAccessTo.manage && !editDriver">
                                <button iccIconButton appearance="flat" (click)="editDriver = true" [title]="'INTERFACE|Zmień' | translate"
                                    *ngIf="hasAccessTo.manage"
                                >
                                    <icc-icon name="edit"></icc-icon>
                                </button>
                            </div>
                        </span>
                    </div>
                </div>
            </div>
        </div>

        <div id="document-actions" *ngIf="hasAccessTo.pickUp && transportRequest?.id && !keyboardOpened">
            <div class="document-actions-row">
                <div class="document-actions-bar document-actions-bar__left">
                </div>

                <div class="document-actions-bar"></div>
                <div class="document-actions-bar document-actions-bar__right">
                    <button
                        iccButton
                        appearance="primary"
                        data-test="delivery-sign"
                        *ngIf="hasAccessTo.pickUp && !transportRequest.isCollected"
                        (click)="collect()"
                    >
                        <icc-icon name="done"></icc-icon>
                        {{ 'TRANSPORT|Potwierdź odbiór' | translate }}
                    </button>
                </div>
            </div>
        </div>

    </div>

    <div class="position-description">
        <span class="title">{{ 'TRANSPORT|Opis' | translate }}</span>

        <div class="icc-card">
            <div class="icc-element" *ngIf="!transportRequest?.id">
                <textarea [ngModel]="transportRequest?.description" (ngModelChange)="changeDescription($event)" name="document-description" [ngModelOptions]="{updateOn: 'blur'}" iccInplaceFocus [placeholder]="'TRANSPORT|Kliknij, aby ustawić opis' | translate"></textarea>
            </div>

            <p  class="document-description" *ngIf="transportRequest?.id">
                {{transportRequest.description}}
            </p>
        </div>
    </div>

    <div class="position-description" *ngIf="!transportRequest?.id">
        <span class="title">{{ 'TRANSPORT|Adres odbioru' | translate }}</span>

        <div class="icc-card">
            <icc-select
                name="document-description"
                [value]="transportRequest?.pickupAddress"
                (valueChange)="changePickupAddress($event)"
            >
                <option
                    *ngFor="let address of (deliveryAddresses || [])"
                    [value]="address.addressLine1 
                        + (address.addressLine2 ? (', ' + address.addressLine2) : '') 
                        + (address.postalCode ? (', ' + address.postalCode) : '') 
                        + (address.city ? (', ' + address.city) : '')
                        + (address.countryId ? (', ' + address.countryId) : '')
                    "
                >
                    {{ 
                        address.addressLine1 
                        + (address.addressLine2 ? (', ' + address.addressLine2) : '') 
                        + (address.postalCode ? (', ' + address.postalCode) : '') 
                        + (address.city ? (', ' + address.city) : '')
                        + (address.countryId ? (', ' + address.countryId) : '') 
                    }}
                </option>
            </icc-select>
        </div>
    </div>

    <div class="position-description"  *ngIf="!transportRequest?.id">
        <span class="title">{{ 'TRANSPORT|Telefon kontaktowy' | translate }}</span>

        <div class="icc-card">
            <div class="icc-element" *ngIf="!transportRequest?.id && transportRequest">
                <icc-input
                    [(ngModel)]="transportRequest.pickupPhoneNumber"
                    name="pickup-phone-number"
                    type="text"
                ></icc-input>
            </div>
        </div>
    </div>

    <div class="position-description" *ngIf="transportRequest?.id && (transportRequest.driverNote || hasAccessTo.pickUp)">
        <span class="title">{{ 'TRANSPORT|Notatka kierowcy' | translate }}</span>

        <div class="icc-card">
            <icc-inplace *ngIf="hasAccessTo.pickUp">
                <ng-template iccTemplate="display">
                    <span *ngIf="transportRequest.driverNote" class="document-description">{{transportRequest.driverNote}}</span>
                    <span *ngIf="!transportRequest.driverNote">{{ 'TRANSPORT|Kliknij, aby ustawić notatkę' | translate }}</span>
                </ng-template>
                <ng-template iccTemplate="content">
                    <textarea [ngModel]="transportRequest.driverNote" (ngModelChange)="changeDriverNote($event)" name="document-description" [ngModelOptions]="{updateOn: 'blur'}" iccInplaceFocus></textarea>
                </ng-template>
            </icc-inplace>

            <p  class="document-description" *ngIf="!hasAccessTo.pickUp">
                {{transportRequest.driverNote}}
            </p>
        </div>
    </div>

    <div class="transport-actions" *ngIf="!transportRequest?.id">
        <button iccButton appearance="primary" (click)="sendTransportRequest()" id="new-transport-button">{{ 'TRANSPORT|Zgłoś transport' | translate }}</button>
    </div>


    <div class="messages" *ngIf="!hasAccessTo.pickUp && transportRequest?.id">
        <span class="title">{{ 'TRANSPORT|Wiadomości' | translate }}</span>
        <div class="new-message">
            <textarea [ngModel]="newMessage" (ngModelChange)="newMessage = $event" name="new-message" [ngModelOptions]="{updateOn: 'blur'}" iccInplaceFocus [placeholder]="'TRANSPORT|Wpisz wiadomość' | translate"></textarea>
            <button iccButton appearance="primary" (click)="sendMessage()" id="new-message-button">{{ 'INTERFACE|Wyślij' | translate }}</button>
        </div>
        <div class="messages-list">
            <div *ngFor="let message of messages" class="message">
                <div class="message-header">
                    <b>{{ message.userName }}</b>
                    <span>{{ message.companyName }}</span>
                    <span>{{ message.created | date: 'short' }}</span>
                </div>
                <div class="message-content" >
                    {{ message.message }}
                </div>
            </div>
        </div>
    </div>

</div>